import { OperationOutcome, Encounter } from '@medplum/fhirtypes';
import { useResource } from '@medplum/react';
import { useParams } from 'react-router-dom';

type Options = {
  encounterId?: string;
  ignoreMissingEncounterId?: boolean;
  setOutcome?: (outcome: OperationOutcome) => void;
};

export const useEncounterFromParams = (
  options?: Options
): Encounter | undefined => {
  const { encounterId } = useParams();

  if (
    !(encounterId || options?.encounterId) &&
    !options?.ignoreMissingEncounterId
  ) {
    throw new Error('Encounter ID not found');
  }

  const id = encounterId || options?.encounterId;

  return useResource<Encounter>(
    { reference: `Encounter/${id}` },
    options?.setOutcome
  );
};
